import {
  contentCss,
  SLeftNavButton,
  SMemoryView,
  SRightNavButton,
  SSpinner,
  SToggleAudioButton,
} from './MemoryViewer.styled'
import { Icon } from 'components/icon'
import { LivePortraitAnimation, SingingPortraitAnimation } from 'components/memory/MemoryAnimation'
import {
  AnimationType,
  SelectedMemory,
  useSingingPortraitSongName,
} from 'components/memory/MemoryUtils'
import { PhotoInProgress } from 'components/photoInProgress/PhotoInProgress'
import { AutoPlayer } from 'components/videoPlayer/autoPlayer/AutoPlayer'
import { useTranslation } from 'next-i18next'
import { ReactElement } from 'react'
import { BREAKPOINTS } from 'utils/styled'
import { GenericAsyncFunction } from 'utils/types'

export default function MemoryView(props: {
  memory?: SelectedMemory
  isAnimating: AnimationType | boolean
  shareModal?: ReactElement
  onPrev?: GenericAsyncFunction | null
  onNext?: GenericAsyncFunction | null
  progressBar?: ReactElement
  muted?: boolean
  toggleMuted?: GenericAsyncFunction
}) {
  const { t } = useTranslation('life_stories')
  const songName = useSingingPortraitSongName(props.memory)

  const isSingingPortrait = props.memory?.selectedAnimation?.animation_type === 'SINGING_PORTRAIT'
  const isStoryPortrait = props.memory?.selectedAnimation?.animation_type === 'STORY_PORTRAIT'

  const isMutable = isSingingPortrait || isStoryPortrait

  const renderMemoryContent = () => {
    if (props.memory?.selectedAnimation && !props.isAnimating) {
      const showZoomed = !isStoryPortrait
      return (
        <AutoPlayer
          src={props.memory.selectedAnimation.file?.url}
          isAuth
          muted={props.muted}
          containerCss={
            showZoomed
              ? contentCss
              : {
                  height: '100%',
                  [`@media ${BREAKPOINTS.LG.max}`]: {
                    height: 'calc(100% - 10rem)',
                  },
                }
          }
        >
          {isMutable && (
            <SToggleAudioButton label={songName} muted={props.muted} onClick={props.toggleMuted} />
          )}
        </AutoPlayer>
      )
    }
    return (
      <PhotoInProgress
        css={contentCss}
        icon={
          props.isAnimating === 'SINGING_PORTRAIT' ? (
            <SingingPortraitAnimation>
              <Icon name="Music" color="white" />
            </SingingPortraitAnimation>
          ) : (
            <LivePortraitAnimation>
              <Icon name="StarWand" color="white" />
            </LivePortraitAnimation>
          )
        }
        spinner={<SSpinner />}
        fitType="contain"
        text={t('life_stories.inside_page.memory_viewer.in_progress_text')}
        isInProgress={!!props.isAnimating}
        src={props.memory?.original_file?.url}
      >
        {props.progressBar}
      </PhotoInProgress>
    )
  }

  return (
    <SMemoryView>
      {props?.shareModal}
      {renderMemoryContent()}
      {!props.isAnimating && props.onPrev && (
        <SLeftNavButton onClick={props.onPrev}>
          <Icon name="ChevronRight" size={36} />
        </SLeftNavButton>
      )}

      {!props.isAnimating && props.onNext && (
        <SRightNavButton onClick={props.onNext}>
          <Icon name="ChevronRight" size={36} />
        </SRightNavButton>
      )}
    </SMemoryView>
  )
}
